import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { Newspaper, ArrowRight } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog/posts").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  const byClub = posts.reduce((acc, p) => {
    (acc[p.club_name] = acc[p.club_name] || []).push(p);
    return acc;
  }, {});

  return (
    <div className="App bg-[#FFF4E6] min-h-screen">
      <Navbar />
      <div className="max-w-6xl mx-auto px-5 py-12">
        <p className="text-xs tracking-[0.2em] uppercase text-[#D94A3D] font-semibold">From our restaurants</p>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight mb-8 flex items-center gap-3"><Newspaper size={40} className="text-[#17324D]" /> The Blog</h1>

        {loading ? (
          <p className="text-[#17324D]/80">Loading posts…</p>
        ) : posts.length === 0 ? (
          <div className="card-brut rounded-xl p-10 text-center">
            <Newspaper size={40} className="mx-auto text-[#D94A3D]" />
            <p className="mt-3 font-semibold text-lg">No posts yet.</p>
            <p className="text-[#17324D]/80">Check back soon for updates from our member restaurants.</p>
          </div>
        ) : (
          Object.entries(byClub).map(([club, list]) => (
            <div key={club} className="mb-12" data-testid={`blog-club-${club}`}>
              <h2 className="font-heading font-bold text-xl border-b border-[#17324D]/15 pb-2 mb-5">{club}</h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {list.map((p) => (
                  <Link to={`/blog/${p.id}`} key={p.id} data-testid={`blog-post-card-${p.id}`}
                    className="card-brut rounded-xl bg-white overflow-hidden flex flex-col">
                    {p.image_url && (
                      <img src={`${BACKEND}${p.image_url}`} alt={p.title} className="w-full h-44 object-cover border-b border-[#17324D]/15" />
                    )}
                    <div className="p-5 flex flex-col flex-1">
                      <h3 className="font-heading font-bold text-lg leading-none">{p.title}</h3>
                      <p className="text-xs text-[#17324D]/60 mt-1">{p.published_at ? new Date(p.published_at).toLocaleDateString() : ""}</p>
                      <p className="text-sm text-[#17324D]/80 mt-2 line-clamp-3 flex-1">{p.body}</p>
                      <span className="mt-3 inline-flex items-center gap-1 text-[#D94A3D] font-semibold text-sm">Read more <ArrowRight size={15} /></span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
